import React from "react";
import { withTranslation } from "react-i18next";
import ScannerBuyContent from "./ScannerBuyContent";
import { getPaymentPlans, PRODUCT_NAMES } from "API/StripeAPI";

class ScannerApiBuyAddins extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addonPlans: []
    };
    this.init();
  }

  async init() {
    let addonPlans = await getPaymentPlans(PRODUCT_NAMES.URL_CHECKER_ADD_ON);
    addonPlans = addonPlans.map(item => {
            const match = item.description.match(/\(([^)]+)\)/);
            if (!match) {
              return null;
            }
            const rangeStr = match[1].replace(/,/g, '');
            let bracket;
            if (rangeStr.includes('–')) {
                const [start, end] = rangeStr.split('–').map(Number);
                bracket = [start, end];
            } else if (rangeStr.includes('+')) {
                const number = parseInt(rangeStr.replace('+', ''), 10);
                bracket = [number];
            } else {
                return null;
            }
            return { ...item, bracket };
        })
        .filter(item => item !== null)
        .sort((a, b) => a.bracket[0] - b.bracket[0]);
    this.setState({ addonPlans: addonPlans });
  }

  render() {
    const { t, i18n } = this.props;
    return (
      <div
        className="d-flex flex-column flex-sm-row w-100"
        style={{ gap: "1rem" }}
      >
        <div className="flex-fill">
          <ScannerBuyContent
            title={t("phish_guard_url_checker.buy.email_addins")}
            // subTitle={t("phish_guard_url_checker.buy.monthly_subtitle")}
            product={t("phish_guard_url_checker.buy.addin_product")}
            tooltip={t("phish_guard_url_checker.buy.addin_tooltip")}
            buyText={t("phish_guard_url_checker.buy.buy_text")}
            optionsList={this.state.addonPlans}
            selectQuantity={true}
            mostPopular={t("phish_guard_url_checker.buy.most_popular")}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ScannerApiBuyAddins);
